import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SubscriptionStatus} from "../../model/subscription-status";
import {SubscriberService} from "../../services/subscriber.service";
import {filter, Subscription} from "rxjs";
import {ModalsService} from "../../services/modals.service";

@Component({
  selector: 'app-subscriptions-page',
  templateUrl: './subscriptions-page.component.html',
  styleUrls: ['./subscriptions-page.component.css'],
  host: {
    class: 'app-page'
  }
})
export class SubscriptionsPageComponent implements OnInit, OnDestroy {
  @ViewChild('privetButton') privetButton: ElementRef;
  @ViewChild('privetPlusButton') privetPlusButton: ElementRef;

  showOnlyActiveSubscriptions: boolean;
  privetSubscriptionStatus: SubscriptionStatus;
  privetPlusSubscriptionStatus: SubscriptionStatus;
  promo: boolean;
  dateEnd: Date;
  loadInProgress: boolean;
  subscription: Subscription;

  constructor(private readonly subscriberService: SubscriberService,
              private readonly modalsService: ModalsService) {
    this.showOnlyActiveSubscriptions = false;
    this.privetSubscriptionStatus = SubscriptionStatus.NO_PROFILE;
    this.privetPlusSubscriptionStatus = SubscriptionStatus.NO_PROFILE;
    this.subscription = new Subscription();
    this.promo = false;
    this.loadInProgress = false;
  }

  ngOnInit(): void {
    this.loadInProgress = true;
    this.subscriberService.loadSubscriptions();

    this.subscription.add(
      this.subscriberService.subscriber
        .pipe(
          filter(subscriber => subscriber !== null)
        )
        .subscribe(subscriber => {
          console.log(subscriber.privetStatus)
          console.log(subscriber.privetPlusStatus)
          this.privetSubscriptionStatus = subscriber.privetStatus;
          this.privetPlusSubscriptionStatus = subscriber.privetPlusStatus;
          this.promo = subscriber.isPromoStatus;
          this.loadInProgress = false;
        })
    );
  }

  activatePrivet(): void {
    if (this.privetSubscriptionStatus != SubscriptionStatus.ACTIVE && this.privetSubscriptionStatus != SubscriptionStatus.ACTIVATING) {
      this.modalsService.showActivateSubscription(false);
    }
  }

  activatePrivetPlus(): void {
    if (this.privetPlusSubscriptionStatus != SubscriptionStatus.ACTIVE && this.privetPlusSubscriptionStatus != SubscriptionStatus.ACTIVATING) {
      this.modalsService.showActivateSubscription(true);
    }
  }

  deactivatePrivet(): void {
    if (this.privetSubscriptionStatus == SubscriptionStatus.ACTIVE) {
      this.modalsService.showDeactivateSubscription(false);
    }
  }

  deactivatePrivetPlus(): void {
    if (this.privetPlusSubscriptionStatus == SubscriptionStatus.ACTIVE) {
      this.modalsService.showDeactivateSubscription(true);
    }
  }

  showPrivetInfo(event: Event): void {
    if (!this.privetButton.nativeElement.contains(event.target)) {
      if (this.privetSubscriptionStatus != SubscriptionStatus.ACTIVATING && this.privetSubscriptionStatus != SubscriptionStatus.DEACTIVATING) {
        this.modalsService.showSubscriptionInfo(false);
      }
    }
  }

  showPrivetPlusInfo(event: Event): void {
    if (!this.privetPlusButton.nativeElement.contains(event.target)) {
      if (this.privetPlusSubscriptionStatus != SubscriptionStatus.ACTIVATING && this.privetPlusSubscriptionStatus != SubscriptionStatus.DEACTIVATING) {
        this.modalsService.showSubscriptionInfo(true);
      }
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getPaidToDate(paidFrom: string | Date): Date {
    const date = new Date(paidFrom);
    date.setDate(date.getDate() + 10);
    return date;
  }

  protected readonly SubscriptionStatus = SubscriptionStatus;
}
